import { Injectable } from '@angular/core';

import { IBetslip } from '../../../../../bet-generation/models';
import { ComboPreventionPreCheckError } from '../../../../errors/pre-check/combo-prevention-pre-check-error';
import { EditBetTypeValidationContext } from '../../../../models/models';
import { ComboPreventionValidator } from '../../bets/combo-prevention.validator';
import { BaseTypeComboPreventionValidator } from '../base-type-combo-prevention.validator';
import { IEditBetTypeBetslipValidator } from '../validators';

@Injectable()
export class EditBetComboPreventionValidator
    extends BaseTypeComboPreventionValidator
    implements IEditBetTypeBetslipValidator<ComboPreventionPreCheckError>
{
    constructor(comboPreventionValidator: ComboPreventionValidator) {
        super(comboPreventionValidator);
    }

    validate(_: IBetslip, context: EditBetTypeValidationContext): ComboPreventionPreCheckError[] {
        return super.validateComboPrevention(context.typeContext);
    }
}
